module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel-suns_access_03-f3829f857922286468aff18eb46238c5.jpg";